import { render } from "./Frauenkreis.vue?vue&type=template&id=771fbee7"
import script from "./Frauenkreis.vue?vue&type=script&lang=js"
export * from "./Frauenkreis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__